export default "__VITE_ASSET__7Uhv2Ph5__"